import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
	name: 'authSlice',
	initialState: {
		id: undefined,
		accessToken: '',
		refreshToken: '',
		birthdaySet: true
	} as AuthState,
	reducers: {
		logout: state => {
			state.id = undefined;
			state.accessToken = '';
			state.refreshToken = '';
			state.birthdaySet = true;
		},
		setUserId: (state, { payload }: PayloadAction<number>) => {
			state.id = +payload;
		},
		setOAuthTokens: (
			state,
			{
				payload: { accessToken, refreshToken }
			}: PayloadAction<OAuthPayload>
		) => {
			state.accessToken = accessToken;
			state.refreshToken = refreshToken;
		},
		setBirthdaySet: (
			state,
			{ payload }: PayloadAction<boolean | undefined>
		) => {
			state.birthdaySet = payload;
		},
		clearAuthState: () => {
			return {
				id: undefined,
				accessToken: '',
				refreshToken: '',
				birthdaySet: true
			} as AuthState;
		}
	}
});

export const {
	setUserId,
	setOAuthTokens,
	logout,
	setBirthdaySet,
	clearAuthState
} = slice.actions;

export default slice.reducer;
